//
import React, { useState, useContext, createContext, useEffect } from "react";

import apiFetech from "../configs/axios";

// ** Utils Imports

const clientCityContext = createContext();

export function ProviderClientCity({ children }) {
  const clientCity = useProviderClientCity();
  return (
    <clientCityContext.Provider value={clientCity}>
      {children}
    </clientCityContext.Provider>
  );
}

export const useClientCity = () => {
  return useContext(clientCityContext);
};

function useProviderClientCity() {
  // ** State
  const [clientCity, setClientCity] = useState({});

  const saveClientCity = (obj) => {
    if(!("name" in obj)){
      obj.name = ""
    }
    if (obj) {
      localStorage.setItem("clientCity", JSON.stringify(obj));
      setClientCity(obj);
    } else {
      setClientCity(obj);
    }
  };

  useEffect(() => {
    async function init() {
      let city = await localStorage.getItem("clientCity");
      if (city !== undefined && city !== null) {
        const cityObj = JSON.parse(city);
        setClientCity({ ...cityObj });
      } else {
        setClientCity({ id: 0, country_id: 0 });
      }
    }
    init();
    return () => {};
  }, []);

  useEffect(() => {
    if (clientCity && Object.keys(clientCity).length > 0) {
      if (clientCity.id !== 0) {
        // // ** Set Header City ID
        apiFetech.interceptors.request.use(
          async function (config) {
            // Do something before request is sent
            const cityObjString =
             await localStorage.getItem("clientCity") || `{id:0}`;
            const cityObj = JSON.parse(cityObjString);
            if(!config.url.includes("search/city_id")){

              if (config.url.includes("?")) {
                if (!config.url.includes("city_id")) {
                  config.url = `${config.url}&city_id=${cityObj?.id}`;
                }
              } else {
                if (!config.url.includes("city_id")) {
                  config.url = `${config.url}?city_id=${cityObj?.id}`;
                }
              }
            }
            
            if (config.url.includes("providers?") || config.url.includes("search/city_id")) {
              
            }else{
              config.headers["city_id"] = cityObj.id;
            }
            return config;
          },
          function (error) {
            // Do something with request error
            return Promise.reject(error);
          }
        );
      }
    }
    return () => {};
  }, [clientCity]);

  // Return State && SetState
  return {
    clientCity,
    saveClientCity
  };
}
